import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { useConfigContext } from '../config';
var typeDefs = {
  size: sizes,
  center: Boolean,
  overlay: Boolean
};
var defaults = function defaults() {
  return {
    size: 'default'
  };
};
export var Spin = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Spin, _Component);
  function Spin() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Spin;
}(Component);
Spin.template = template;
Spin.typeDefs = typeDefs;
Spin.defaults = defaults;